<template>
  <div class="sangre-layout">
    <nav class="sangre-sidebar">
      <ul class="sangre-nav">
        <li>
          <button class="button-71" :class="{ selected: isSelected('SangreAlexander') }" @click="goTo('SangreAlexander')">Alexander</button>
        </li>
        <li>
          <button class="button-71" :class="{ selected: isSelected('SangreAntonio') }" @click="goTo('SangreAntonio')">Antonio</button>
        </li>
        <li>
          <button class="button-71" :class="{ selected: isSelected('SangreFacundo') }" @click="goTo('SangreFacundo')">Facundo</button>
        </li>
        <li>
          <button class="button-71" :class="{ selected: isSelected('SangreBenjamin') }" @click="goTo('SangreBenjamin')">Benjamín</button>
        </li>
        <li class="sidebar-divider"></li>
        <li>
          <button v-if="puedeEscribir" class="button-71 btn-import" :class="{ selected: isSelected('ImportarPDF') }" @click="goTo('ImportarPDF')">Importar PDF</button>
        </li>
      </ul>
    </nav>
    <div class="sangre-content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SangreIndex',
  computed: {
    puedeEscribir() {
      return this.$store.getters['auth/puede']('sangre.examenes', 'escribir');
    },
  },
  methods: {
    goTo(name) {
      this.$router.push({ name });
    },
    isSelected(name) {
      return this.$route.name === name;
    }
  }
};
</script>

<style scoped>
.sangre-layout {
  display: flex;
  min-height: 100vh;
}
.sangre-sidebar {
  width: 260px;
  min-width: 220px;
  background: #f8f8f8;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2em 1em 1em 1em;
  gap: 2em;
  height: 100vh;
  box-sizing: border-box;
}
.sangre-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}
.sangre-nav li {
  display: block;
  width: 100%;
}
.sangre-content {
  margin-top: 1rem;
  flex: 1;
  padding: 2em;
  overflow-x: auto;
}
.button-71 {
  background-color: #0078d4;
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08), 0 0.5px 1.5px rgba(0,0,0,0.08);
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.7em 1.5em;
  margin: 0.2em 0;
  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;
  outline: none;
  width: 12em;
  text-align: left;
}
.button-71.selected {
  background-color: #22c55e !important;
  color: #fff;
  box-shadow: 0 4px 12px rgba(34,197,94,0.15);
}
.button-71:hover,
.button-71:focus {
  background-color: #005fa3;
  box-shadow: 0 4px 8px rgba(0,0,0,0.12);
  transform: translateY(-2px) scale(1.03);
}
.button-71:active {
  background-color: #004c87;
  transform: none;
}
.btn-import {
  background-color: #6b46c1;
}
.btn-import:hover,
.btn-import:focus {
  background-color: #553c9a;
}
.btn-import.selected {
  background-color: #22c55e !important;
}
.sidebar-divider {
  border-top: 1px solid #e0e0e0;
  margin: 0.5em 0;
  list-style: none;
}
</style>
